export const BlogPostsTableColumns = (isArabic) => [
    { id: 'title', label: isArabic ? 'العنوان' : 'Title', align: 'start' },
    { id: 'categories', label: isArabic ? 'التصنيفات' : 'Categories', align: 'start' },
    { id: 'show_in_home', label: isArabic ? 'عرض في الرئيسية' : 'Show in Home', align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' },
];
